import { Checkbox, message, Table } from 'antd'
import { useAttemptListener } from 'dev-masters-react-kit'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import useAllTrackDynamicColumns from '../../../utils/hooks/useAllTrackDynamicColumns'
import useSongsForTableSelector from '../../../utils/hooks/useSongsForTableSelector'
import {
  attemptDeleteSong,
  attemptSearchSongs,
  ListSongsOrderBy,
  Song,
} from '../../../utils/redux/songsSlice'
import {
  listenerMiddleware,
  store,
  useAppDispatch,
  useAppSelector,
} from '../../../utils/redux/store'
import { OrderDirection } from '../../../utils/dto.d'
import { usePlayerContext } from '../../../components/Player/PlayerContext'
import usePagination from '../../../utils/hooks/usePagination'

// import { usePlayerContext } from '../../../components/Player/PlayerContext'
// import { attemptPlaySong, playSong, setQueue } from '../../../utils/redux/appSlice'

interface Props {
  onEditSong: (song: Song) => void
  setSelectedSongs: Dispatch<SetStateAction<Song[] | undefined>>
}
export default function AllTracksTable({ onEditSong, setSelectedSongs }: Props) {
  const dispatch = useAppDispatch()

  const onDeleteSong = (song: Song) => {
    setSelectedSongs((prev) => prev?.filter((_song) => _song._id !== song._id))
    dispatch(attemptDeleteSong(song._id))
  }
  useEffect(() => {
    fetchSongs(pagination.current, pagination.pageSize)
  }, [])

  useAttemptListener({
    listenerMiddleware: listenerMiddleware,
    attempt: attemptDeleteSong,
    onFulfilled: (action) =>
      message.success(`${action.meta.arg} has been successfully removed!`),
  })
  
  const { songs, total, fetchSongs } = useSongsForTableSelector()
  const { pagination, onPaginationChange } = usePagination({ fetchCallback: fetchSongs })
  
  const { columns, checkBoxOptions, displayedColumns, setDisplayedColumns } =
  useAllTrackDynamicColumns({ actions: { onEditSong, onDeleteSong /* onPlaySong  */ } })
  const { setQueue, play } = usePlayerContext()
  const isLoading = useAttemptListener({
    initialPendingState: true,
    listenerMiddleware: listenerMiddleware,
    attempt: attemptSearchSongs,
  })

  return (
    <Table<Song>
      title={() => (
        <Checkbox.Group
          value={displayedColumns}
          options={checkBoxOptions}
          onChange={setDisplayedColumns}
        />
      )}
      onRow={(song, rowIndex) => {
        return {
          onClick: (event) => {
            // setQueue([song])
            // setTimeout(() => play(), 100)
          },
        }
      }}
      loading={isLoading}
      size={'small'}
      sticky
      columns={columns}
      dataSource={songs}
      rowKey={(song) => song._id}
      pagination={{
        ...pagination,
        total,
        onChange: onPaginationChange,
      }}
      // scroll={{ y: '70vh' }}
    />
  )
}
